import Config from "../Config";
import ErrorMessage from "../libs/helpers/ErrorMessage";
import { buildFetchOptions } from "./utils";

// listCreas (POST /api/v1/crea) takes pageNum/limit/filters (e.g. title) all together in the
// body, not the query string — unlike most other list endpoints in this app (brand, company),
// which are GET-based. No Redux here (deprecated for this project) — pairs with useCreas.
export const getCreaListApi = async ({ data = {} }) => {
  const res = await fetch(
    `${Config.apiBaseurl}/${Config.apis.crea.list}`,
    buildFetchOptions("POST", { pageNum: 1, ...data }),
  );

  const response = await res.json();

  if (res.ok) {
    return response;
  }
  const { statusText, status } = res;
  const { httpStatus, clientType, description } = response;
  throw new ErrorMessage(
    statusText,
    description,
    httpStatus,
    status,
    clientType,
  );
};

export const getCreaEntityApi = async ({ headers, page }) => {
  const res = await fetch(
    `${Config.apiBaseurl}/${Config.apis.crea.list}/entity`,
    {
      method: "GET",
      headers,
    },
  );

  const response = await res.json();

  if (res.ok) {
    return response;
  }
  const { statusText, status } = res;
  const { httpStatus, clientType, description } = response;
  throw new ErrorMessage(
    statusText,
    description,
    httpStatus,
    status,
    clientType,
  );
};
//

export const getCreaDetailApi = async ({ headers, id }) => {
  const res = await fetch(
    `${Config.apiBaseurl}/${Config.apis.crea.detail}/${id}`,
    {
      method: "GET",
      headers,
    },
  );

  const response = await res.json();

  if (res.ok) {
    return response;
  }
  const { statusText, status } = res;
  const { httpStatus, clientType, description } = response;
  throw new ErrorMessage(
    statusText,
    description,
    httpStatus,
    status,
    clientType,
  );
};

export const getCreaSnapshotApi = async ({ headers, id }) => {
  const res = await fetch(
    `${Config.apiBaseurl}/${Config.apis.crea.detail}/${id}/snapshot`,
    {
      method: "GET",
      headers,
    },
  );

  const response = await res;

  if (res.ok) {
    const blob = res.blob();
    return blob.then((b) => {
      return URL.createObjectURL(b);
    });
  }
  const { statusText, status } = res;
  const { httpStatus, clientType, description } = response;
  throw new ErrorMessage(
    statusText,
    description,
    httpStatus,
    status,
    clientType,
  );
};

export const editCreaDetailApi = async ({ headers, id, data }) => {
  const res = await fetch(
    `${Config.apiBaseurl}/${Config.apis.crea.detail}/${id}`,
    {
      method: "PUT",
      headers,
      body: JSON.stringify(data),
    },
  );

  const response = await res.json();

  if (res.ok) {
    return response;
  }
  const { statusText, status } = res;
  const { httpStatus, clientType, description } = response;
  throw new ErrorMessage(
    statusText,
    description,
    httpStatus,
    status,
    clientType,
  );
};
